import React, { memo, useMemo, useState } from 'react'
import {
    InfoSnackbar,
    SuccessSnackbar,
    WarningSnackbar,
    ErrorSnackbar,
    CustomBackdrop,
} from '../components'
import { FeedbackContext } from './FeedbackContext'
import { FeedbackContextData } from './FeedbackContext.types'
import { FeedbackProviderProps } from './FeedbackProvider.types'

function FeedbackProvider({ children }: FeedbackProviderProps) {
    const [info, setInfo] = useState<string>()
    const [success, setSuccess] = useState<string>()
    const [warning, setWarning] = useState<string>()
    const [error, setError] = useState<string>()
    const [backdrop, setBackdrop] = useState(false)
    const [backdropText, setBackdropText] = useState<string>()

    const value = useMemo<FeedbackContextData>(
        () => ({
            showInfo: setInfo,
            showSuccess: setSuccess,
            showWarning: setWarning,
            showError: setError,
            showBackdrop: (message?: string) => {
                setBackdrop(true)
                setBackdropText(message)
            },
            closeBackdrop: () => {
                setBackdrop(false)
                setBackdropText(undefined)
            },
        }),
        []
    )

    return (
        <FeedbackContext.Provider value={value}>
            {children}
            <InfoSnackbar message={info} onClose={() => setInfo(undefined)} />
            <SuccessSnackbar
                message={success}
                onClose={() => setSuccess(undefined)}
            />
            <WarningSnackbar
                message={warning}
                onClose={() => setWarning(undefined)}
            />
            <ErrorSnackbar
                message={error}
                onClose={() => setError(undefined)}
            />
            <CustomBackdrop open={backdrop} message={backdropText} />
        </FeedbackContext.Provider>
    )
}

export default memo(FeedbackProvider)
